import Image from 'next/image';
import React from 'react';
import ClientCarousel from './home/client-carousel';
import ScheduleCall from './common/schedule-call';
type Props = {
    path: any;
    alt: string;
    title: string;
    width: number;
    height: number;
    pageTitle: string;
    desc: string;
    className: string;
};
const AppProjectDetailHero: React.FC<Props> = ({ path, alt, title, width, height, pageTitle, desc, className }) => {
    return (
        <section className={`hero product-min-height ${className}`}>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="lg:grid lg:grid-cols-12 hero-row gap-6 relative z-[1] h-full w-full">
                    <div className="lg:col-span-6">
                        <div className="inline-flex flex-col lg:items-start gap-5 hero-content justify-center h-full">
                            <h1 className="mb-0 dark:text-textcolor">{pageTitle}</h1>
                            <p className="mb-0 font-semibold text-secondary dark:text-secondary">
                                {' '}
                                {desc?.trim().endsWith('.') ? desc : `${desc}.`}
                            </p>
                            <ScheduleCall />
                        </div>
                    </div>
                    <div className="lg:col-span-5 lg:col-start-8">
                        <div className="text-center lg:text-start lg:self-center py-9">
                            <div className="app-img-wrapper">
                                <Image
                                    src={path}
                                    width={width}
                                    height={height}
                                    alt={alt}
                                    title={title}
                                    className="img-fluid"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default AppProjectDetailHero;
